import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 870F391E-A069-461E-9296-904B34308D98
 * name format-letter-starts-with
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-letter-starts-with.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatLetterStartsWithIcon = createSvgIcon(<><path d="M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M4 18V15H2V20H22V18Z" /></>, 'FormatLetterStartsWithIcon');
export default FormatLetterStartsWithIcon